import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-circle bg-white text-gray-900 font-bold flex align-items-center justify-content-center round-container" }
const _hoisted_2 = ["textContent"]

import { toRefs } from 'vue';

interface StepInterface {
  title: string;
  id: number;
}

interface PropsInterface {
  className: string;
  step: StepInterface;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Step',
  props: {
    className: {},
    step: {}
  },
  setup(__props: any) {

const props = __props;
const { className, step } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-content-center align-items-center flex-column step", _unref(className)])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(step).id + 1), 1),
    _createElementVNode("label", {
      class: "font-bold",
      textContent: _toDisplayString(_unref(step).title)
    }, null, 8, _hoisted_2)
  ], 2))
}
}

})